export const diffDates = (date1: number, date2: number) => {
  let diff = date1 - date2
  return diff / (1000 * 3600 * 24)
}